module.exports = __webpack_public_path__ + "static/media/TaskManagement_admin_001.27ce6c84.png";